import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_CREATE_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADED,
  PATH_ENTERPRISE_ACCOUNTS_V2, EVENT_ENTERPRISE_ACCOUNT_UPDATED, EVENT_ENTERPRISE_ACCOUNT_CREATED
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_ENTERPRISE_ACCOUNT_CREATE_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_ENTERPRISE_ACCOUNTS_V2}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body: action.payload,
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADED,
          payload: data.response
        }
      }).rxEmit(EVENT_ENTERPRISE_ACCOUNT_CREATED).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/EnterpriseAccountCreateEpic.js